export default __webpack_public_path__ + "static/media/khoa_cao.8844158e.jpg";